import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiFormHelperTextStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            whiteSpace: 'pre-line',
            '&.Mui-error': {
                color: variables.colors.error.main,
            },
            '&.Mui-required': {
                color: variables.colors.error.main,
            },
        },
    },
});

export default createMuiFormHelperTextStyles;
